<app-roster-roster-link *ngIf="showToolBar" [termCode]="termCode" [crn]="crn"></app-roster-roster-link>
<app-text [alias]="'roster_main_text_non_ip_grading'" [interpolationObject]="gradeSchedule"
          *ngIf="showForNonIPGrade && gradeSchedule"></app-text>
<app-text [alias]="'roster_main_text_ip_grading'" [interpolationObject]="gradeSchedule"
          *ngIf="!showForNonIPGrade && gradeSchedule"></app-text>
<app-text [alias]="'roster_main_text_grade_submitted'" [interpolationObject]="courseService.currentCourse"
          *ngIf="courseService.currentCourse?.canCourseBeGraded"></app-text>
<app-text [alias]="'roster_main_text_grading_closed'" *ngIf="!courseService.currentCourse?.isGradingOpen"></app-text>

<ng-container *ngTemplateOutlet="rosterSaveSubmitButtons"></ng-container>


<div class="row" *ngIf="this.mainValidationErrorMessage">
    <div class="large-12">{{this.mainValidationErrorMessage}}</div>
</div>
<mat-card *ngIf="showForNonIPGrade">
    <div class="row">
        <div class="large-12 column">
            <mat-card-title>Filter Roster</mat-card-title>
        </div>
    </div>
    <div class="row">
        <div class="large-3 column">
            <mat-form-field appearance="fill">
                <mat-label>Search By Name or SID</mat-label>
                <input matInput [(ngModel)]="searchText" (keyup)="updateSearchByText()"
                       placeholder="search by name or SID">
            </mat-form-field>
        </div>

        <div class="large-3 column">
            <mat-form-field appearance="fill">
                <mat-label>Grade Status</mat-label>
                <mat-select [(ngModel)]="searchGrade" (selectionChange)="updateSearchByGrades()">
                    <mat-option value="All Students">All Students</mat-option>
                    <mat-option value="Students have iGrade">Grades Entered</mat-option>
                    <mat-option value="Students does not have iGrade">Grades Not Entered</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="large-3 column">
            <mat-form-field appearance="fill">
                <mat-label> Enrollment Source</mat-label>
                <mat-select [(ngModel)]="searchEnrollment" (selectionChange)="updateSearchByEnrollmentSource()">
                    <mat-option value="All Students">All Students</mat-option>
                    <mat-option *ngFor="let enrollmentRec of enrollmentSourceList"
                                [value]="enrollmentRec.description">{{enrollmentRec.description}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="large-1 column">
            <app-button (clickedEvent)="updateSearchClear()" [icon]="'cancel'" [buttonConfig]="{themeColor: 'accent'}">
                Reset
            </app-button>
        </div>
    </div>
</mat-card>
<div>

</div>
<div *ngIf="!studentExistsInDataSource && isDataLoaded">
    No student found.
</div>
<app-text [alias]="'roster_main_data_still_loading'" *ngIf="!isDataLoaded"></app-text>
<app-loading-wrapper [loading]="!isDataLoaded">

    <table mat-table matSort [dataSource]="dataSource" [hidden]="!studentExistsInDataSource">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name"
                class="header-row">
                Name (Last, First)
            </th>
            <td mat-cell *matCellDef="let student"><a href="mailto:{{student.emailAddress}}"> {{student.bannerLastName}}
                , {{student.bannerFirstName}}</a></td>
        </ng-container>
        <ng-container matColumnDef="pronouns">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                class="header-row">
                Pronouns
            </th>
            <td mat-cell *matCellDef="let student">{{student.pronouns}}</td>
        </ng-container>
        <ng-container matColumnDef="studentId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Student ID"
                class="header-row">Student ID
            </th>
            <td mat-cell *matCellDef="let student">{{student.studentId}}</td>
        </ng-container>
        <ng-container matColumnDef="numUnit">
            <th mat-header-cell *matHeaderCellDef class="roster-unit-content-header ">Units</th>
            <td mat-cell *matCellDef="let student" class="roster-unit-content">{{student.numUnit}}</td>
        </ng-container>
        <ng-container matColumnDef="gradeBanner">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Banner Grade"
                class="roster-current-grade-header">Current<br>Grade
            </th>
            <td mat-cell *matCellDef="let student" class="roster-current-grade-content">{{student.gradeBanner}}</td>
        </ng-container>
        <ng-container matColumnDef="gradeIGrade">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by iGrade"
                class="roster-new-grade-header">New<br>Grade
            </th>
            <td mat-cell *matCellDef="let student" class="roster-new-grade-content">
                <div *ngIf="
                    !readOnlyMode && (gradeSchedule?.isOpen  ||this.gradeScheduleInFuture)  &&
                    ((!inIPGrading && student.canGradeBeModified && student.numberOfGradeChange<=student.maxNumberGradeChange && !student.hasGraduated)
                    || rosterService.isGradingIP(inIPGrading, gradeListIP, student)) ; else readOnlyGradeChange;"
                     class="roster-grade-drop-down">
                    <mat-select [(ngModel)]="student.gradeIGrade"
                                (selectionChange)="showCustomStatement(student,$event.value)">
                        <mat-option [value]=""></mat-option>
                        <mat-option
                                *ngFor="let validGradeList of getValidGradingList(student.gradeRule, student.gradeType)"
                                [value]="validGradeList.validGrade">{{validGradeList.validGrade }}</mat-option>
                    </mat-select>
                </div>
                <ng-template #readOnlyGradeChange>
                    <div [matTooltip]="cannotModifyReason(student)" [matTooltipClass]="'multiline-tooltip'">
                        <div>{{student.gradeIGrade}}</div>
                    </div>
                </ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="gradeRule">
            <th mat-header-cell *matHeaderCellDef class="roster-grade-level-header">Grade<br>Level</th>
            <td mat-cell *matCellDef="let student" class="roster-grade-level-content">{{student.gradeRule}}</td>
        </ng-container>
        <ng-container matColumnDef="gradeType">
            <th mat-header-cell *matHeaderCellDef class="roster-grade-basis-header">Grade<br>Basis</th>
            <td mat-cell *matCellDef="let student" class="roster-grade-basis-content">{{student.gradeType}}</td>
        </ng-container>
        <ng-container matColumnDef="enrollmentSource">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by enrollment source"
                class="roster-enrollment-source-header">Enrollment<br>Source
            </th>
            <td mat-cell *matCellDef="let student"
                class="roster-enrollment-source-content">{{student.enrollmentSource}}</td>
        </ng-container>
        <ng-container matColumnDef="addNotes">
            <th mat-header-cell *matHeaderCellDef class="roster-add-notes-header">Add<br>Notes</th>
            <td mat-cell *matCellDef="let student" class="roster-add-notes-content">
                <app-button *ngIf="!readOnlyMode" [icon]="'note_add'"
                            (clickedEvent)="showAddNotes(student)"></app-button>

            </td>
        </ng-container>
        <ng-container matColumnDef="viewNotes">
            <th mat-header-cell *matHeaderCellDef class="roster-view-notes-header">View<br>Notes</th>
            <td mat-cell *matCellDef="let student" class="roster-view-notes-content">
                <app-button [icon]="'notes'" (clickedEvent)="showAllNotes(student)"
                            *ngIf="student?.comment?.length > 0" [buttonConfig]="{themeColor: 'accent'}"></app-button>

            </td>
        </ng-container>
        <ng-container matColumnDef="gradeHistory">
            <th mat-header-cell *matHeaderCellDef class="roster-grade-history-header">Grade<br>History</th>
            <td mat-cell *matCellDef="let student" class="roster-grade-history-content">
                <app-button [icon]="'assignment'" (clickedEvent)="viwGradeChangeHistory(student)"
                            [hidden]="student?.changeHistory?.length === 0"></app-button>

            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator showFirstLastButtons id="rosterPaginator" class="do-not-show"></mat-paginator>
    <ng-container *ngTemplateOutlet="rosterSaveSubmitButtons"></ng-container>
</app-loading-wrapper>
<div *ngIf="dataSource?.data.length === 0 && isDataLoaded && inIPGrading">
    No student found with valid IP grade.
</div>
<div class="roster-excel-download" id="roster-table">
    <table id="excel-table">
        <thead>
        <tr>
            <th>Name (Last, First)</th>
            <th>Pronouns</th>
            <th>Student ID</th>
            <th># Units</th>
            <th>Current<br>Grade</th>
            <th>New<br>Grade</th>
            <th>Grade<br>Level</th>
            <th>Grade<br>Basis</th>
            <th>Enrollment<br>Source</th>
            <th>Notes</th>
        </tr>
        </thead>

        <tbody>

        <tr *ngFor="let student of rosterService.currentRoster?.roster">
            <td><a href="mailto:{{student.emailAddress}}"> {{student.bannerLastName}}, {{student.bannerFirstName}}</a>
            </td>
            <td>{{student.pronouns}}</td>
            <td>{{student.studentId}}</td>
            <td>{{student.numUnit}}</td>
            <td>{{student.gradeBanner}}</td>
            <td>{{student.gradeIGrade}}</td>
            <td>{{student.gradeRule}}</td>
            <td>{{student.gradeType}}</td>
            <td>{{student.enrollmentSource}}</td>
            <td>
                <div *ngFor="let comment of student?.comment">
                    {{comment.comment}}<br>
                </div>
            </td>

        </tr>

        </tbody>
    </table>
</div>

<ng-template #rosterSaveSubmitButtons>
    <app-roster-roster-button
            *ngIf="(rosterService.currentRoster?.roster?.length > 0 && showForNonIPGrade && dataSource?.data)  && !readOnlyMode"
            [termCode]="termCode" [crn]="crn"
            [isDataLoaded]="isDataLoaded"
            (requestUpdateRoster)="sendButtonNewRoster($event)"
            [updateStudentList]="dataSource?.data"
            (processSaveGrade)="onSaveGrade($event)"
            (mainValidationErrorMessage)="onValidateGrade($event)"
            (isDataLoadedChange)=setIsDataLoadedSubmitButton($event)
            [gradeGDList]="gradeListGD"
            [allowReSubmitRoster]="rosterService.currentRoster?.course?.allowReSubmitRoster"
            [gradeIList]="gradeListI"></app-roster-roster-button>
</ng-template>